import repository from "../Repository";

/**
 * ランキング関連のAPIにリクエストします
 */
const ranking = "/ranking";
const runner = "/runner";
const teamRanking = "/team/ranking";
const teamRunner = "/team/runner";
const records = "/team/runner/records";
export default {
  /**
   * ランキングを取得します
   * @param params
   */
  getRanking(params) {
    return repository.get(ranking, { params });
  },

  /**
   * ランナー情報を取得します
   * @param params
   */
  getRunner(params) {
    return repository.get(runner, { params });
  },

  /**
   * チーム対抗時のランキングを取得します
   * @param params
   */
  getTeamRanking(params) {
    return repository.get(teamRanking, { params });
  },

  /**
   * 企業対抗時の完走証を取得します
   * @param params
   */
  getTeamRunner(params) {
    return repository.get(teamRunner, { params });
  },

  /**
   * チーム対抗時の個人記録を取得します
   * @param params
   */
  getTeamRunnerRecords(params) {
    return repository.get(records, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/contents/RankingRunnerRepository.js